<template>
  <div style="height: 70%;">
    <div class="box">
      <aside>
        <!-- <img src="../../images/Mirror.png"
             alt="404 Image" /> -->
      </aside>
      <main>
        <h1>Sorry!</h1>
        <p>
          要么你不够酷，无法访问此网页，要么它不存在<em>. . . 你的社交生活.</em>
        </p>
        <button @click="$router.go(-2)">返回！</button>
      </main>
    </div>

  </div>
</template>

<script>
export default {};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fontdiner+Swanky&family=Roboto:wght@500&display=swap");
* {
  box-sizing: 0;
  margin: 0;
  padding: 0;
  /* cursor: url("../../images/cursors-edge.png"), auto; */
}

div {
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(50%, white),
    color-stop(50%, #383838)
  );
  background: linear-gradient(to right, white 50%, #383838 50%);
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5;
  color: white;
}

.box {
  display: -webkit-box;
  -webkit-box-align: center;
  align-items: center;
  height: 100vh;
  max-width: 100vmax;
  width: 93vw;
  margin: 0 auto;
}
div > * {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-flow: column;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  height: 100vh;
  max-width: 500px;
  width: 100%;
  padding: 2.5rem;
}

aside {
  overflow: hidden;
  /* background-image: url("../../images/right-edges.png"); */
  background-position: top right;
  background-repeat: no-repeat;
  background-size: 30px 96.1%;
  margin-left: 320px;
}
aside img {
  display: block;
  height: auto;
  width: 90%;
}

main {
  text-align: center;
}
main h1 {
  font-family: "Fontdiner Swanky", cursive;
  font-size: 4rem;
  color: #c5dc50;
}
main p {
  margin-bottom: 2.5rem;
}
main p em {
  font-style: italic;
  color: #c5dc50;
}
main button {
  font-family: "Fontdiner Swanky", cursive;
  font-size: 1rem;
  color: #383838;
  border: none;
  background-color: #f36a6f;
  padding: 1rem 2.5rem;
  -webkit-transform: skew(-5deg);
  transform: skew(-5deg);
  -webkit-transition: all 0.1s ease;
  transition: all 0.1s ease;
  /* cursor: url("../../images/cursors-eye.png"), auto; */
}
main button:hover {
  background-color: #c5dc50;
  -webkit-transform: scale(1.15);
  transform: scale(1.15);
}
</style>